import { NewsletterBlock } from "@/components/Layout";
import { useContent } from "@/context/ContentContext";
import { AboutHero, AboutBanner, AboutTimeline, AboutValues, AboutCertifications, AboutFaq, AboutConnect } from "@/pages/about/sections";
import Seo from "@/components/Seo";

export default function About() {
  const { about: a, footer } = useContent();
  const certs = a.certifications || { completed: [], inProgress: [] };
  const faq = a.faq;

  return (
    <div className="pt-20">
      <Seo
        title="About Kim Kornachuk | The Marketer Who Builds from Zero"
        description="From Manila to Bahrain to Los Angeles: the story of a product marketing and GTM leader who stands up B2B marketing engines from scratch and scales them globally."
        path="/about"
        jsonLd={faq?.items?.length ? {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faq.items.map((it) => ({
            "@type": "Question",
            name: it.q,
            acceptedAnswer: { "@type": "Answer", text: it.a },
          })),
        } : undefined}
      />
      <AboutHero a={a} />
      <AboutBanner a={a} />
      <AboutTimeline a={a} />
      <AboutValues a={a} />
      <AboutCertifications certs={certs} />
      <AboutFaq faq={faq} />
      <AboutConnect a={a} footer={footer} />
      <NewsletterBlock />
    </div>
  );
}
